module.exports = __webpack_public_path__ + "img/add-on.5a83fc0e.svg";